import React from 'react';
import ChevronLeftIcon from '@heroicons/react/solid/ChevronLeftIcon.js';
import ChevronRightIcon from '@heroicons/react/solid/ChevronRightIcon.js';
import clsx from 'clsx';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';
import { Button } from '../Button/index.js';
const Arrow = ({ disabled, onClick, direction }) => {
    return (React.createElement("div", { className: clsx('flex items-center self-stretch h-full absolute z-10 p-2', direction === 'right' ? 'end-0' : 'start-0', disabled && 'hidden') },
        React.createElement(Button, { variant: "basic", className: "shadow", rounded: true, leadingIcon: direction === 'left' ? (React.createElement(ChevronLeftIcon, { className: "rtl:-scale-x-100" })) : (React.createElement(ChevronRightIcon, { className: "rtl:-scale-x-100" })), size: "lg", onClick: onClick })));
};
export function LeftArrow() {
    const { isFirstItemVisible, scrollPrev, visibleElements, initComplete } = React.useContext(VisibilityContext);
    const [disabled, setDisabled] = React.useState(!initComplete || (initComplete && isFirstItemVisible));
    React.useEffect(() => {
        if (visibleElements.length) {
            setDisabled(isFirstItemVisible);
        }
    }, [isFirstItemVisible, visibleElements]);
    return (React.createElement(Arrow, { disabled: disabled, onClick: () => scrollPrev(), direction: "left" }));
}
export function RightArrow() {
    const { isLastItemVisible, scrollNext, visibleElements } = React.useContext(VisibilityContext);
    const [disabled, setDisabled] = React.useState(!visibleElements.length && isLastItemVisible);
    React.useEffect(() => {
        if (visibleElements.length) {
            setDisabled(isLastItemVisible);
        }
    }, [isLastItemVisible, visibleElements]);
    return (React.createElement(Arrow, { disabled: disabled, onClick: () => scrollNext(), direction: "right" }));
}
//# sourceMappingURL=CarouselArrow.js.map